import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import components from './components'
import store from './store'
import { router } from './router'
import {Message} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'styles/index.scss'
import './utils/errorImg/index' //用于显示在img中无图片的情况下，显示默认的图片


//全局处理提示消息
const resetMessage = (options) => {
  if (typeof (options) === 'string') {
    return Message({
      showClose: true,
      duration: 2000,
      type: 'info',
      message: options,
    });
  }
  return Message({ ...options, showClose: true });
};
['error', 'success', 'info', 'warning'].forEach((item) => {
  resetMessage[item] = (msg) => Message({
    dangerouslyUseHTMLString: true,
    showClose: true,
    duration: 2000,
    type: item,
    message: msg,
  });
});

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(components)
Vue.use(require('vue-wechat-title')) //设置单页面浏览器标题
Vue.prototype.$message = resetMessage;
export {resetMessage}

window.APP= new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
